"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SubclientController {
    constructor() {
        this.URL_CROP_IMG = '/crop/pic/background/grape';
        this.URL_SUBCLIENT_IMG = '/client.pic/143/photo.jpg?square=true';
        this.fakeData = [
            {
                id: 1432,
                c_wineseq: 'ZZA',
                nombre_comercial: 'Biomemakers SL',
                c_tipo_cliente: 9999,
                comments: null,
                created_at: '2020-08-31 15:39:39',
                updated_at: '2021-09-03 12:18:46',
                c_wineseq_prefix: null,
                shop_club_date_start: null,
                shop_club_date_end: null,
                shop_club_date_next_payment: null,
                shop_club_plan: null,
                shop_stripe_customer_id: null,
                shop_name: null,
                shop_vat_country: null,
                shop_vat_number: null,
                shop_shipping_address: null,
                is_distributor: true,
                access_id: null,
                shop_clubend_notification1: null,
                shop_clubend_notification2: null,
                shop_club_date_cancelrenew: null,
                shop_missing_payment: false,
                shop_club_item: null,
                s3_path: null,
                portal_id: 1,
                is_api19: true,
                fastcheckout_upper_limit: 50,
                fastcheckout_lower_limit: 10,
                fastcheckout_owner_id: null,
                extlab_id: null,
                monthly_billing: false,
                report_contact_email: null,
                report_contact_phone: null,
                laboratory_id: null,
                internal_type: 'real',
                can_research: false,
                subsidiary_id: null,
                netsuite_synced_at: null,
                netsuite_id: null,
                billing_name: null,
                crops: [
                    {
                        id: 163,
                        name: 'Potato',
                        botanical_name: 'Solamum tuberosum',
                        approved: true,
                        intel_active: true,
                        activated_at: null,
                        created_at: '2018-09-06 10:17:33',
                        updated_at: '2018-09-06 10:17:33',
                        logo_name: 'tuber',
                        is_woody: false,
                        pivot: { client_id: 1432, crop_id: 163 },
                    },
                    {
                        id: 15,
                        name: 'Banana, Plantain',
                        botanical_name: 'Musa paradisiaca',
                        approved: true,
                        intel_active: false,
                        activated_at: null,
                        created_at: '2018-09-06 10:17:33',
                        updated_at: '2018-09-06 10:17:33',
                        logo_name: 'banana',
                        is_woody: true,
                        pivot: { client_id: 1432, crop_id: 15 },
                    },
                    {
                        id: 196,
                        name: 'Sugarcane',
                        botanical_name: 'Saccharum officinarum',
                        approved: true,
                        intel_active: false,
                        activated_at: null,
                        created_at: '2018-09-06 10:17:33',
                        updated_at: '2018-09-06 10:17:33',
                        logo_name: 'cane',
                        is_woody: false,
                        pivot: { client_id: 1432, crop_id: 196 },
                    },
                    {
                        id: 5,
                        name: 'Almond',
                        botanical_name: 'Prunus dulcis',
                        approved: true,
                        intel_active: false,
                        activated_at: null,
                        created_at: '2018-09-06 10:17:33',
                        updated_at: '2018-09-06 10:17:33',
                        logo_name: 'nut',
                        is_woody: true,
                        pivot: { client_id: 1432, crop_id: 5 },
                    },
                    {
                        id: 2,
                        name: 'Grapes',
                        botanical_name: 'Vitis vinifera',
                        approved: true,
                        intel_active: true,
                        activated_at: null,
                        created_at: '2018-09-06 10:17:29',
                        updated_at: '2018-09-06 10:17:29',
                        logo_name: 'grape',
                        is_woody: true,
                        pivot: { client_id: 1432, crop_id: 2 },
                    },
                ],
            },
            {
                id: 1433,
                c_wineseq: 'ZZA',
                nombre_comercial: 'Farmer Inc.',
                c_tipo_cliente: 9999,
                comments: null,
                created_at: '2020-08-31 15:39:39',
                updated_at: '2021-09-03 12:18:46',
                c_wineseq_prefix: null,
                shop_club_date_start: null,
                shop_club_date_end: null,
                shop_club_date_next_payment: null,
                shop_club_plan: null,
                shop_stripe_customer_id: null,
                shop_name: null,
                shop_vat_country: null,
                shop_vat_number: null,
                shop_shipping_address: null,
                is_distributor: true,
                access_id: null,
                shop_clubend_notification1: null,
                shop_clubend_notification2: null,
                shop_club_date_cancelrenew: null,
                shop_missing_payment: false,
                shop_club_item: null,
                s3_path: null,
                portal_id: 1,
                is_api19: true,
                fastcheckout_upper_limit: 50,
                fastcheckout_lower_limit: 10,
                fastcheckout_owner_id: null,
                extlab_id: null,
                monthly_billing: false,
                report_contact_email: null,
                report_contact_phone: null,
                laboratory_id: null,
                internal_type: 'real',
                can_research: false,
                subsidiary_id: null,
                netsuite_synced_at: null,
                netsuite_id: null,
                billing_name: null,
                crops: [
                    {
                        id: 13,
                        name: 'Asparagus',
                        botanical_name: 'Asparagus officinalis',
                        approved: true,
                        intel_active: false,
                        activated_at: null,
                        created_at: '2018-09-06 10:17:33',
                        updated_at: '2018-09-06 10:17:33',
                        logo_name: 'veggie',
                        is_woody: false,
                        pivot: { client_id: 1432, crop_id: 13 },
                    },
                    {
                        id: 14,
                        name: 'Avocado',
                        botanical_name: 'Persea americona',
                        approved: true,
                        intel_active: false,
                        activated_at: null,
                        created_at: '2018-09-06 10:17:33',
                        updated_at: '2018-09-06 10:17:33',
                        logo_name: 'avocado',
                        is_woody: true,
                        pivot: { client_id: 1432, crop_id: 14 },
                    },
                    {
                        id: 163,
                        name: 'Potato',
                        botanical_name: 'Solamum tuberosum',
                        approved: true,
                        intel_active: true,
                        activated_at: null,
                        created_at: '2018-09-06 10:17:33',
                        updated_at: '2018-09-06 10:17:33',
                        logo_name: 'tuber',
                        is_woody: false,
                        pivot: { client_id: 1432, crop_id: 163 },
                    },
                    {
                        id: 15,
                        name: 'Banana, Plantain',
                        botanical_name: 'Musa paradisiaca',
                        approved: true,
                        intel_active: false,
                        activated_at: null,
                        created_at: '2018-09-06 10:17:33',
                        updated_at: '2018-09-06 10:17:33',
                        logo_name: 'banana',
                        is_woody: true,
                        pivot: { client_id: 1432, crop_id: 15 },
                    },
                ],
            },
            {
                id: 1434,
                c_wineseq: 'ZZA',
                nombre_comercial: 'bayer Z',
                c_tipo_cliente: 9999,
                comments: null,
                created_at: '2020-08-31 15:39:39',
                updated_at: '2021-09-03 12:18:46',
                c_wineseq_prefix: null,
                shop_club_date_start: null,
                shop_club_date_end: null,
                shop_club_date_next_payment: null,
                shop_club_plan: null,
                shop_stripe_customer_id: null,
                shop_name: null,
                shop_vat_country: null,
                shop_vat_number: null,
                shop_shipping_address: null,
                is_distributor: true,
                access_id: null,
                shop_clubend_notification1: null,
                shop_clubend_notification2: null,
                shop_club_date_cancelrenew: null,
                shop_missing_payment: false,
                shop_club_item: null,
                s3_path: null,
                portal_id: 1,
                is_api19: true,
                fastcheckout_upper_limit: 50,
                fastcheckout_lower_limit: 10,
                fastcheckout_owner_id: null,
                extlab_id: null,
                monthly_billing: false,
                report_contact_email: null,
                report_contact_phone: null,
                laboratory_id: null,
                internal_type: 'real',
                can_research: false,
                subsidiary_id: null,
                netsuite_synced_at: null,
                netsuite_id: null,
                billing_name: null,
                crops: [
                    {
                        id: 13,
                        name: 'Asparagus',
                        botanical_name: 'Asparagus officinalis',
                        approved: true,
                        intel_active: false,
                        activated_at: null,
                        created_at: '2018-09-06 10:17:33',
                        updated_at: '2018-09-06 10:17:33',
                        logo_name: 'veggie',
                        is_woody: false,
                        pivot: { client_id: 1432, crop_id: 13 },
                    },
                    {
                        id: 14,
                        name: 'Avocado',
                        botanical_name: 'Persea americona',
                        approved: true,
                        intel_active: false,
                        activated_at: null,
                        created_at: '2018-09-06 10:17:33',
                        updated_at: '2018-09-06 10:17:33',
                        logo_name: 'avocado',
                        is_woody: true,
                        pivot: { client_id: 1432, crop_id: 14 },
                    },
                    {
                        id: 196,
                        name: 'Sugarcane',
                        botanical_name: 'Saccharum officinarum',
                        approved: true,
                        intel_active: false,
                        activated_at: null,
                        created_at: '2018-09-06 10:17:33',
                        updated_at: '2018-09-06 10:17:33',
                        logo_name: 'cane',
                        is_woody: false,
                        pivot: { client_id: 1432, crop_id: 196 },
                    },
                    {
                        id: 5,
                        name: 'Almond',
                        botanical_name: 'Prunus dulcis',
                        approved: true,
                        intel_active: false,
                        activated_at: null,
                        created_at: '2018-09-06 10:17:33',
                        updated_at: '2018-09-06 10:17:33',
                        logo_name: 'nut',
                        is_woody: true,
                        pivot: { client_id: 1432, crop_id: 5 },
                    },
                    {
                        id: 2,
                        name: 'Grapes',
                        botanical_name: 'Vitis vinifera',
                        approved: true,
                        intel_active: true,
                        activated_at: null,
                        created_at: '2018-09-06 10:17:29',
                        updated_at: '2018-09-06 10:17:29',
                        logo_name: 'grape',
                        is_woody: true,
                        pivot: { client_id: 1432, crop_id: 2 },
                    },
                ],
            },
            {
                id: 1435,
                c_wineseq: 'ZZA',
                nombre_comercial: 'Biome Makers Test 1',
                c_tipo_cliente: 9999,
                comments: null,
                created_at: '2020-08-31 15:39:39',
                updated_at: '2021-09-03 12:18:46',
                c_wineseq_prefix: null,
                shop_club_date_start: null,
                shop_club_date_end: null,
                shop_club_date_next_payment: null,
                shop_club_plan: null,
                shop_stripe_customer_id: null,
                shop_name: null,
                shop_vat_country: null,
                shop_vat_number: null,
                shop_shipping_address: null,
                is_distributor: true,
                access_id: null,
                shop_clubend_notification1: null,
                shop_clubend_notification2: null,
                shop_club_date_cancelrenew: null,
                shop_missing_payment: false,
                shop_club_item: null,
                s3_path: null,
                portal_id: 1,
                is_api19: true,
                fastcheckout_upper_limit: 50,
                fastcheckout_lower_limit: 10,
                fastcheckout_owner_id: null,
                extlab_id: null,
                monthly_billing: false,
                report_contact_email: null,
                report_contact_phone: null,
                laboratory_id: null,
                internal_type: 'real',
                can_research: false,
                subsidiary_id: null,
                netsuite_synced_at: null,
                netsuite_id: null,
                billing_name: null,
                crops: [
                    {
                        id: 2,
                        name: 'Grapes',
                        botanical_name: 'Vitis vinifera',
                        approved: true,
                        intel_active: true,
                        activated_at: null,
                        created_at: '2018-09-06 10:17:29',
                        updated_at: '2018-09-06 10:17:29',
                        logo_name: 'grape',
                        is_woody: true,
                        pivot: { client_id: 1432, crop_id: 2 },
                    },
                ],
            },
            {
                id: 1436,
                c_wineseq: 'ZZA',
                nombre_comercial: 'DEMO Client INC',
                c_tipo_cliente: 9999,
                comments: null,
                created_at: '2020-08-31 15:39:39',
                updated_at: '2021-09-03 12:18:46',
                c_wineseq_prefix: null,
                shop_club_date_start: null,
                shop_club_date_end: null,
                shop_club_date_next_payment: null,
                shop_club_plan: null,
                shop_stripe_customer_id: null,
                shop_name: null,
                shop_vat_country: null,
                shop_vat_number: null,
                shop_shipping_address: null,
                is_distributor: true,
                access_id: null,
                shop_clubend_notification1: null,
                shop_clubend_notification2: null,
                shop_club_date_cancelrenew: null,
                shop_missing_payment: false,
                shop_club_item: null,
                s3_path: null,
                portal_id: 1,
                is_api19: true,
                fastcheckout_upper_limit: 50,
                fastcheckout_lower_limit: 10,
                fastcheckout_owner_id: null,
                extlab_id: null,
                monthly_billing: false,
                report_contact_email: null,
                report_contact_phone: null,
                laboratory_id: null,
                internal_type: 'real',
                can_research: false,
                subsidiary_id: null,
                netsuite_synced_at: null,
                netsuite_id: null,
                billing_name: null,
                crops: [
                    {
                        id: 13,
                        name: 'Asparagus',
                        botanical_name: 'Asparagus officinalis',
                        approved: true,
                        intel_active: false,
                        activated_at: null,
                        created_at: '2018-09-06 10:17:33',
                        updated_at: '2018-09-06 10:17:33',
                        logo_name: 'veggie',
                        is_woody: false,
                        pivot: { client_id: 1432, crop_id: 13 },
                    },
                    {
                        id: 14,
                        name: 'Avocado',
                        botanical_name: 'Persea americona',
                        approved: true,
                        intel_active: false,
                        activated_at: null,
                        created_at: '2018-09-06 10:17:33',
                        updated_at: '2018-09-06 10:17:33',
                        logo_name: 'avocado',
                        is_woody: true,
                        pivot: { client_id: 1432, crop_id: 14 },
                    },
                    {
                        id: 163,
                        name: 'Potato',
                        botanical_name: 'Solamum tuberosum',
                        approved: true,
                        intel_active: true,
                        activated_at: null,
                        created_at: '2018-09-06 10:17:33',
                        updated_at: '2018-09-06 10:17:33',
                        logo_name: 'tuber',
                        is_woody: false,
                        pivot: { client_id: 1432, crop_id: 163 },
                    },
                    {
                        id: 15,
                        name: 'Banana, Plantain',
                        botanical_name: 'Musa paradisiaca',
                        approved: true,
                        intel_active: false,
                        activated_at: null,
                        created_at: '2018-09-06 10:17:33',
                        updated_at: '2018-09-06 10:17:33',
                        logo_name: 'banana',
                        is_woody: true,
                        pivot: { client_id: 1432, crop_id: 15 },
                    },
                    {
                        id: 196,
                        name: 'Sugarcane',
                        botanical_name: 'Saccharum officinarum',
                        approved: true,
                        intel_active: false,
                        activated_at: null,
                        created_at: '2018-09-06 10:17:33',
                        updated_at: '2018-09-06 10:17:33',
                        logo_name: 'cane',
                        is_woody: false,
                        pivot: { client_id: 1432, crop_id: 196 },
                    },
                    {
                        id: 5,
                        name: 'Almond',
                        botanical_name: 'Prunus dulcis',
                        approved: true,
                        intel_active: false,
                        activated_at: null,
                        created_at: '2018-09-06 10:17:33',
                        updated_at: '2018-09-06 10:17:33',
                        logo_name: 'nut',
                        is_woody: true,
                        pivot: { client_id: 1432, crop_id: 5 },
                    },
                    {
                        id: 2,
                        name: 'Grapes',
                        botanical_name: 'Vitis vinifera',
                        approved: true,
                        intel_active: true,
                        activated_at: null,
                        created_at: '2018-09-06 10:17:29',
                        updated_at: '2018-09-06 10:17:29',
                        logo_name: 'grape',
                        is_woody: true,
                        pivot: { client_id: 1432, crop_id: 2 },
                    },
                ],
            },
            {
                id: 1437,
                c_wineseq: 'ZZA',
                nombre_comercial: 'Demo Subclient 11',
                c_tipo_cliente: 9999,
                comments: null,
                created_at: '2020-08-31 15:39:39',
                updated_at: '2021-09-03 12:18:46',
                c_wineseq_prefix: null,
                shop_club_date_start: null,
                shop_club_date_end: null,
                shop_club_date_next_payment: null,
                shop_club_plan: null,
                shop_stripe_customer_id: null,
                shop_name: null,
                shop_vat_country: null,
                shop_vat_number: null,
                shop_shipping_address: null,
                is_distributor: true,
                access_id: null,
                shop_clubend_notification1: null,
                shop_clubend_notification2: null,
                shop_club_date_cancelrenew: null,
                shop_missing_payment: false,
                shop_club_item: null,
                s3_path: null,
                portal_id: 1,
                is_api19: true,
                fastcheckout_upper_limit: 50,
                fastcheckout_lower_limit: 10,
                fastcheckout_owner_id: null,
                extlab_id: null,
                monthly_billing: false,
                report_contact_email: null,
                report_contact_phone: null,
                laboratory_id: null,
                internal_type: 'real',
                can_research: false,
                subsidiary_id: null,
                netsuite_synced_at: null,
                netsuite_id: null,
                billing_name: null,
                crops: [
                    {
                        id: 14,
                        name: 'Avocado',
                        botanical_name: 'Persea americona',
                        approved: true,
                        intel_active: false,
                        activated_at: null,
                        created_at: '2018-09-06 10:17:33',
                        updated_at: '2018-09-06 10:17:33',
                        logo_name: 'avocado',
                        is_woody: true,
                        pivot: { client_id: 1432, crop_id: 14 },
                    },
                    {
                        id: 163,
                        name: 'Potato',
                        botanical_name: 'Solamum tuberosum',
                        approved: true,
                        intel_active: true,
                        activated_at: null,
                        created_at: '2018-09-06 10:17:33',
                        updated_at: '2018-09-06 10:17:33',
                        logo_name: 'tuber',
                        is_woody: false,
                        pivot: { client_id: 1432, crop_id: 163 },
                    },
                    {
                        id: 15,
                        name: 'Banana, Plantain',
                        botanical_name: 'Musa paradisiaca',
                        approved: true,
                        intel_active: false,
                        activated_at: null,
                        created_at: '2018-09-06 10:17:33',
                        updated_at: '2018-09-06 10:17:33',
                        logo_name: 'banana',
                        is_woody: true,
                        pivot: { client_id: 1432, crop_id: 15 },
                    },
                    {
                        id: 196,
                        name: 'Sugarcane',
                        botanical_name: 'Saccharum officinarum',
                        approved: true,
                        intel_active: false,
                        activated_at: null,
                        created_at: '2018-09-06 10:17:33',
                        updated_at: '2018-09-06 10:17:33',
                        logo_name: 'cane',
                        is_woody: false,
                        pivot: { client_id: 1432, crop_id: 196 },
                    },
                    {
                        id: 5,
                        name: 'Almond',
                        botanical_name: 'Prunus dulcis',
                        approved: true,
                        intel_active: false,
                        activated_at: null,
                        created_at: '2018-09-06 10:17:33',
                        updated_at: '2018-09-06 10:17:33',
                        logo_name: 'nut',
                        is_woody: true,
                        pivot: { client_id: 1432, crop_id: 5 },
                    },
                    {
                        id: 2,
                        name: 'Grapes',
                        botanical_name: 'Vitis vinifera',
                        approved: true,
                        intel_active: true,
                        activated_at: null,
                        created_at: '2018-09-06 10:17:29',
                        updated_at: '2018-09-06 10:17:29',
                        logo_name: 'grape',
                        is_woody: true,
                        pivot: { client_id: 1432, crop_id: 2 },
                    },
                ],
            },
            {
                id: 1438,
                c_wineseq: 'ZZA',
                nombre_comercial: 'Example',
                c_tipo_cliente: 9999,
                comments: null,
                created_at: '2020-08-31 15:39:39',
                updated_at: '2021-09-03 12:18:46',
                c_wineseq_prefix: null,
                shop_club_date_start: null,
                shop_club_date_end: null,
                shop_club_date_next_payment: null,
                shop_club_plan: null,
                shop_stripe_customer_id: null,
                shop_name: null,
                shop_vat_country: null,
                shop_vat_number: null,
                shop_shipping_address: null,
                is_distributor: true,
                access_id: null,
                shop_clubend_notification1: null,
                shop_clubend_notification2: null,
                shop_club_date_cancelrenew: null,
                shop_missing_payment: false,
                shop_club_item: null,
                s3_path: null,
                portal_id: 1,
                is_api19: true,
                fastcheckout_upper_limit: 50,
                fastcheckout_lower_limit: 10,
                fastcheckout_owner_id: null,
                extlab_id: null,
                monthly_billing: false,
                report_contact_email: null,
                report_contact_phone: null,
                laboratory_id: null,
                internal_type: 'real',
                can_research: false,
                subsidiary_id: null,
                netsuite_synced_at: null,
                netsuite_id: null,
                billing_name: null,
                crops: [
                    {
                        id: 13,
                        name: 'Asparagus',
                        botanical_name: 'Asparagus officinalis',
                        approved: true,
                        intel_active: false,
                        activated_at: null,
                        created_at: '2018-09-06 10:17:33',
                        updated_at: '2018-09-06 10:17:33',
                        logo_name: 'veggie',
                        is_woody: false,
                        pivot: { client_id: 1432, crop_id: 13 },
                    },
                    {
                        id: 14,
                        name: 'Avocado',
                        botanical_name: 'Persea americona',
                        approved: true,
                        intel_active: false,
                        activated_at: null,
                        created_at: '2018-09-06 10:17:33',
                        updated_at: '2018-09-06 10:17:33',
                        logo_name: 'avocado',
                        is_woody: true,
                        pivot: { client_id: 1432, crop_id: 14 },
                    },
                    {
                        id: 163,
                        name: 'Potato',
                        botanical_name: 'Solamum tuberosum',
                        approved: true,
                        intel_active: true,
                        activated_at: null,
                        created_at: '2018-09-06 10:17:33',
                        updated_at: '2018-09-06 10:17:33',
                        logo_name: 'tuber',
                        is_woody: false,
                        pivot: { client_id: 1432, crop_id: 163 },
                    },
                ],
            },
        ];
        this.fakeCurrent = {
            id: 1432,
            c_wineseq: 'ZZA',
            nombre_comercial: 'Biomemakers SL',
            c_tipo_cliente: 9999,
            comments: null,
            created_at: '2020-08-31 15:39:39',
            updated_at: '2021-09-03 12:18:46',
            c_wineseq_prefix: null,
            shop_club_date_start: null,
            shop_club_date_end: null,
            shop_club_date_next_payment: null,
            shop_club_plan: null,
            shop_stripe_customer_id: null,
            shop_name: null,
            shop_vat_country: null,
            shop_vat_number: null,
            shop_shipping_address: null,
            is_distributor: true,
            access_id: null,
            shop_clubend_notification1: null,
            shop_clubend_notification2: null,
            shop_club_date_cancelrenew: null,
            shop_missing_payment: false,
            shop_club_item: null,
            s3_path: null,
            portal_id: 1,
            is_api19: true,
            fastcheckout_upper_limit: 50,
            fastcheckout_lower_limit: 10,
            fastcheckout_owner_id: null,
            extlab_id: null,
            monthly_billing: false,
            report_contact_email: null,
            report_contact_phone: null,
            laboratory_id: null,
            internal_type: 'real',
            can_research: false,
            subsidiary_id: null,
            netsuite_synced_at: null,
            netsuite_id: null,
            billing_name: null,
            crops: [
                {
                    id: 163,
                    name: 'Potato',
                    botanical_name: 'Solamum tuberosum',
                    approved: true,
                    intel_active: true,
                    activated_at: null,
                    created_at: '2018-09-06 10:17:33',
                    updated_at: '2018-09-06 10:17:33',
                    logo_name: 'tuber',
                    is_woody: false,
                    pivot: { client_id: 1432, crop_id: 163 },
                },
                {
                    id: 15,
                    name: 'Banana, Plantain',
                    botanical_name: 'Musa paradisiaca',
                    approved: true,
                    intel_active: false,
                    activated_at: null,
                    created_at: '2018-09-06 10:17:33',
                    updated_at: '2018-09-06 10:17:33',
                    logo_name: 'banana',
                    is_woody: true,
                    pivot: { client_id: 1432, crop_id: 15 },
                },
                {
                    id: 196,
                    name: 'Sugarcane',
                    botanical_name: 'Saccharum officinarum',
                    approved: true,
                    intel_active: false,
                    activated_at: null,
                    created_at: '2018-09-06 10:17:33',
                    updated_at: '2018-09-06 10:17:33',
                    logo_name: 'cane',
                    is_woody: false,
                    pivot: { client_id: 1432, crop_id: 196 },
                },
                {
                    id: 5,
                    name: 'Almond',
                    botanical_name: 'Prunus dulcis',
                    approved: true,
                    intel_active: false,
                    activated_at: null,
                    created_at: '2018-09-06 10:17:33',
                    updated_at: '2018-09-06 10:17:33',
                    logo_name: 'nut',
                    is_woody: true,
                    pivot: { client_id: 1432, crop_id: 5 },
                },
                {
                    id: 2,
                    name: 'Grapes',
                    botanical_name: 'Vitis vinifera',
                    approved: true,
                    intel_active: true,
                    activated_at: null,
                    created_at: '2018-09-06 10:17:29',
                    updated_at: '2018-09-06 10:17:29',
                    logo_name: 'grape',
                    is_woody: true,
                    pivot: { client_id: 1432, crop_id: 2 },
                },
            ],
        };
        this.subclient = null;
        this.subclients = [];
        this.loaderAllSubclient = false;
        this.loaderCurrentSubclient = false;
        this.loadingChange = false;
    }
    async changeSubclient(subclientId, cropId, redirection) {
        this.loadingChange = true;
        if (cropId === null) {
            try {
                await fetch(`/subclient/switch/${subclientId}`);
                if (redirection.length > 0) {
                    location.href = redirection;
                }
                else {
                    location.reload();
                }
            }
            catch (error) {
                console.log(error);
            }
        }
        else {
            try {
                await fetch(`/subclient/switch/${subclientId}/${cropId}`);
                if (redirection.length > 0) {
                    location.href = redirection;
                }
                else {
                    location.reload();
                }
            }
            catch (error) {
                console.log(error);
            }
        }
        setTimeout(() => {
            this.loadingChange = false;
        }, 100000);
    }
    async fetchAllSubclients(url) {
        this.loaderAllSubclient = true;
        try {
            const request = await fetch(url);
            const response = await request.json();
            this.subclients = response;
            this.loaderAllSubclient = false;
        }
        catch (error) {
            this.subclients = this.fakeData;
            console.error(error);
            this.loaderAllSubclient = false;
        }
    }
    async fetchCurrentSubclient(url) {
        this.loaderCurrentSubclient = true;
        try {
            const request = await fetch(url);
            const response = await request.json();
            this.subclient = response;
            this.loaderCurrentSubclient = false;
        }
        catch (error) {
            this.subclient = this.fakeCurrent;
            console.error(error);
            setTimeout(() => {
                this.loaderCurrentSubclient = false;
            }, 2000);
        }
    }
    get allSubclients() {
        return this.subclients;
    }
    get currentSubclient() {
        return this.subclient;
    }
}
exports.default = SubclientController;
